import { render } from "./TrailerPage.vue?vue&type=template&id=bfa36438&scoped=true"
import script from "./TrailerPage.vue?vue&type=script&lang=js"
export * from "./TrailerPage.vue?vue&type=script&lang=js"

import "./TrailerPage.vue?vue&type=style&index=0&id=bfa36438&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa36438"]])

export default __exports__